export enum CancellationDeterrents {
  SKIP = 'Skip Shipment',
  DISCOUNT = '33% Discount',
  UPDATE = 'Change Frequency',
}
